import React from 'react';
import { ActivityIndicator } from 'react-native';
import DownloadIcon from './DownloadIcon';
import Button from './Button';

interface ExportButtonProps {
  onPress: () => void,
  exporting?: boolean,
  testID?: string,
}

const ExportButton = ({ onPress, exporting, testID }: ExportButtonProps) => <Button
  style={{ width: 119 }}
  disabled={exporting}
  title={'Export\t'}
  affirmative
  children={exporting ? <ActivityIndicator /> : <DownloadIcon />}
  {...{ onPress, testID }}
/>;

export default ExportButton;
